import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    antecedentesGinecoObstetricos: [],
  },

  getters: {
    getAntecedentesGinecoObstetricos: (state) => state.antecedentesGinecoObstetricos,
  },

  mutations: {
    SET_ANTECEDENTES_GINECOOBSTETRICOS(state, antecedentesGinecoObstetricos) {
      state.antecedentesGinecoObstetricos = antecedentesGinecoObstetricos;
    },
  },

  actions: {
    async fetchAntecedentesGinecoObstetricos({ commit }, idHistoriaClinica) {
      await axios
        .get(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/anteGinecoObstetricos`)
        .then((response) => {
          commit('SET_ANTECEDENTES_GINECOOBSTETRICOS', response.data.data);
        });
    },

    async saveAntecedentesGinecoObstetricos(context, antecedentesGinecoObstetricos) {
      const { idHistoriaClinica } = context.rootState.historiaClinica;
      await axios
        .post(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/anteGinecoObstetricos`, antecedentesGinecoObstetricos);
    },

    async updateAntecedentesGinecoObstetricos(_, antecedentesGinecoObstetricos) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/historiaClinica/${
            antecedentesGinecoObstetricos.fk_idHistoriaClinica
          }/anteGinecoObstetricos/${
            antecedentesGinecoObstetricos.fk_idAntecedentesGinecoObstetricos}`,
          antecedentesGinecoObstetricos,
        );
    },
  },
};
